import React from "react";

export default function HomeworkTab({
  homeworkFilter, setHomeworkFilter,
  groupHomework,
  handleOpenHomework,
  handleCheckHomework,
}) {
  return (
    <div className="homework-tab-content section-card">
      <div className="homework-header">
        <div className="homework-filter-tabs">
          <button
            className={`filter-tab ${homeworkFilter === 'all' ? 'active' : ''}`}
            onClick={() => setHomeworkFilter('all')}
          >
            All
          </button>
          <button
            className={`filter-tab ${homeworkFilter === 'assigned' ? 'active' : ''}`}
            onClick={() => setHomeworkFilter('assigned')}
          >
            Assigned
          </button>

          <button
            className={`filter-tab ${homeworkFilter === 'reviewed' ? 'active' : ''}`}
            onClick={() => setHomeworkFilter('reviewed')}
          >
            Reviewed
          </button>
        </div>
        <button className="add-homework-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Send Homework
        </button>
      </div>

      <div className="homework-list">
        {(groupHomework || [])
        .filter(homework => homeworkFilter === 'all' || homework.status === homeworkFilter)
        .map(homework => (
          <div
            key={homework.id}
            className="homework-item"
            onClick={() => handleOpenHomework(homework.id)}
            style={{ cursor: 'pointer' }}
          >
            <div className="homework-info">
              <h3 className="homework-title">{homework.title || 'Untitled Homework'}</h3>
              <div className="homework-meta">
                <span className="due-date">Due: {homework.dueDate ? new Date(homework.dueDate).toLocaleDateString() : 'No due date'}</span>
                <span className={`status-badge ${homework.status || 'draft'}`}>
                  {(homework.status || 'draft').charAt(0).toUpperCase() + (homework.status || 'draft').slice(1)}
                </span>
                {homework.grade && (
                  <span className="grade-badge">Grade: {homework.grade}%</span>
                )}
              </div>
              <div className="homework-progress">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${(homework.tasks || []).length > 0
                        ? ((homework.tasks || []).filter(t => t.completed).length / (homework.tasks || []).length) * 100
                        : 0}%`
                    }}
                  />
                </div>

              </div>
            </div>

            <div className="homework-actions" onClick={(e) => e.stopPropagation()}>
              {(homework.status || 'draft') === 'assigned' && (
                <button className="action-btn submit-btn" onClick={() => handleCheckHomework(homework.id)}>
                  Check Homework
                </button>
              )}

              {(homework.status || 'draft') === 'reviewed' && (
                <button className="action-btn view-btn" onClick={() => handleCheckHomework(homework.id)}>
                  View Feedback
                </button>
              )}
              <button className="action-btn details-btn">
                View Details
              </button>
            </div>
          </div>
        ))}

        {(groupHomework || []).filter(homework => homeworkFilter === 'all' || homework.status === homeworkFilter).length === 0 && (
          <div className="no-homework-message">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9,22 9,12 15,12 15,22"/>
            </svg>
            <p>No homework found for this filter.</p>
          </div>
        )}
      </div>
    </div>
  );
}
